/**
 * friDay Mweb Configurations
 */

module.exports = {
  injectMockData: true, // for dev mode. if true and inject mock
  webCacheExpireTime: 300,
  sid: () => {
    let sid = 879
    if (/(best-uat|best-sit|localhost|10\.100)/i.test(location.host)) {
      sid = 879
    }
    if (/best-sit/i.test(location.host)) {
      sid = 879
    }
    return sid
  },
  subDomain: () => {
    let sub = 'best'
    if (/(best-uat|10\.100)/i.test(location.host)) {
      sub = 'best-uat'
    }
    if (/(best-sit|localhost)/i.test(location.host)) {
      sub = 'best-sit'
    }
    return sub
  },
  title: 'friDay嚴選',
  description: '【friDay嚴選】是friDay購物專為美安會員成立的專屬購物網站，週週嚴選數十樣商品，提供更優惠的價格及更高的現金回饋，【friDay嚴選】及【friDay購物】永遠是美安會員網路購物的最佳選擇！',
  apiPath: (cusApiRoot) => {
    let schema = 'https://'
    let subdomain = ''
    let domain = '.shopping.friday.tw'
    let apiRoot = '/mobileapi/'
    if (/(best-uat|10\.100|localhost)/i.test(location.host)) {
      subdomain = 'best-uat'
    } else if (/best-sit/i.test(location.host)) {
      subdomain = 'best-sit'
    } else {
      subdomain = 'best'
    }

    if (cusApiRoot) {
      apiRoot = cusApiRoot
    }

    return schema + subdomain + domain + apiRoot
  },
  loginDomain: () => {
    const domain = '.shopping.friday.tw'
    let subdomain = 'best'

    if (/best-uat/i.test(location.host)) {
      subdomain = 'best-uat'
    }
    if (/(best-sit|localhost)/i.test(location.host)) {
      subdomain = 'best-sit'
    }
    return 'https://' + subdomain + domain
  },
  loggoutUrl: () => {
    const dev = /ec2-(sit|sit2|uat)/i.test(location.origin) ? '-test' : ''
    return `https://member${dev}.friday.tw/fri/sso/logout?post_logout_redirect_uri=${location.origin}/mobileweb/logout`
  },
}
